import DOMPurify from "dompurify";

/**
 * Renders a trusted-authored HTML string produced by the admin RichTextEditor.
 * Everything is passed through DOMPurify before being injected into the DOM to
 * guard against XSS if raw HTML ever slips into the DB (e.g. via legacy data).
 *
 * `className` is applied to the wrapping div so callers can theme the prose
 * container (default: Tailwind `prose` classes for readable typography).
 */
export default function RichText({
  html = "",
  className = "prose prose-slate max-w-none prose-sm sm:prose-base prose-a:text-sky-600 prose-a:no-underline hover:prose-a:underline",
  testId,
}) {
  if (!html) return null;
  const clean = DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
  return (
    <div
      className={className}
      data-testid={testId}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
